<template>
  <div class="payment-page" v-if="order">
    <div class="title-payment">
      <p>Payments</p>
      <button @click="showModalAddPaidItem = true">+</button>
    </div>

    <table class="mt-3">
      <tr v-for="item in order.order_info.cart_items" :key="item.cart_item_id">
        <th style="width: 65%" class="name-add">
          {{ item.description }}
          <div class="d-inline" v-if="item.can_delete">
            <button class="btn btn-danger btn-sm" @click="deleteCartItem(item.cart_item_id)">
              Delete
            </button>
          </div>
        </th>
        <th style="width: 30%" class="text-payment"></th>
        <th style="width: 5%%" class="text-value">${{ item.price }}</th>
      </tr>

      <!-- result -->
      <tr class="result-line">
        <th>
          <p class="name-add">Refund</p>
          <p class="pt-2 text-result">Total due</p>
        </th>
        <th></th>
        <th>
          <p class="refund-value">${{ order.order_info.cart_total.refund }}</p>
          <p class="pt-2 text-result text-value">${{ order.order_info.cart_total.total_pay }}</p>
        </th>
      </tr>
    </table>

    <div class="d-flex justify-content-center mt-5">
      <button @click="onCloseOrderClick" class="btn-pay">
        Pay & close order
      </button>
    </div>

    <modal-add-paid-item-v2
      ref="addPaidItemModalRef"
      v-if="order && order.order_info"
      v-show="showModalAddPaidItem"
      @close="showModalAddPaidItem = false"
      :cart-items="cartItems"
      :order-id="order.order_info.order_id"
      @saved="onSavedAddPayedItem"
    />

    <modal-add
      :title="'Add Paid Item'"
      v-if="isShowCloseOrderModal"
      @close="isShowCloseOrderModal = false"
    >
      <div class="select-credit">
        <p class="title-credit-card">Select credit card</p>
        <div class="d-flex align-items-center mt-3" v-for="card in creditcards" :key="card.creditcard_id">
          <label class="checkbox-custom">
            <input type="radio" v-model="selectedCardId" :id="card.creditcard_id" :value="card.creditcard_id" />
            <span class="checkmark-new"></span>
          </label>
          <p class="text-credit ml-3">{{card.creditcard_details}}</p>
        </div>
      </div>

      <div class="select-credit mt-3" style="cursor: pointer" @click="onAddCardClick">
        <div class="d-flex align-items-center">
          <img src="@/assets/images/plus-icon-blue.svg" alt="" />
          <p class="text-credit ml-4">Add credit card</p>
        </div>
      </div>

      <div></div>
      <div class="d-flex justify-content-center mt-5">
        <button class="btn-dialog ok-btn" @click="onPayClick">Pay</button>
      </div>
    </modal-add>
  </div>
</template>

<script>
import DibbleAPI from "@/api";
import DibbleJS from "@/dibble";
import DibbleApi from "@/api";
import ModalAdd from "@/components/RentalInfo/Modal/AddOption";
import ModalAddPaidItemV2 from "@/components/Rental/OrderPage/ModalAddPayItemV2";
import {EventBus} from "@/utils/event-bus";

export default {
  name: "Payments",
  data() {
    return {
      orderId: this.$route.params.id,
      order: null,
      showModalAddPaidItem: false,
      isShowCloseOrderModal: false,

      selectedCardId: null,
      creditcards: [],
      cartItems: null,
    };
  },
  components: {
    ModalAdd, ModalAddPaidItemV2
  },
  watch: {
    selectedCardId(ccId) {
      const params = {
        request: DibbleApi.api.setDefaultCc,
        order_id: this.order.order_info.order_id,
        creditcard_id: ccId
      }
      DibbleJS.showLoader()
      DibbleJS.callApiRequest(params, response => {
        DibbleJS.hideLoader()
        if (!DibbleApi.isResponseSuccess(response)) {
          DibbleJS.toastErrorMessage(response.message);
        }
      });
    }
  },
  created() {
    EventBus.$emit("currentViewOrderId", this.orderId);
    this.loadOrderInfo();
  },
  methods: {
    loadOrderInfo() {
      const params = {
        request: DibbleAPI.api.adminGetRentalBoatOrder,
        order_id: this.orderId
      }
      DibbleJS.showLoader();
      DibbleJS.callApiRequest(params, this._onLoadOrderSuccess, this._onLoadOrderFailed)
    },
    _onLoadOrderSuccess(response) {
      DibbleJS.hideLoader();
      if (DibbleApi.isResponseSuccess(response)) {
        this.order = this.orderOrigin = response;
        this.onGetRentalBoatExtras();
        this.selectedCardId = parseInt(this.order.order_info.default_creditcard_id, 10);
        const params = {
          request: DibbleApi.api.getUserCreditcards,
          user_id: this.order.order_info.client_user_id //todo
        };
        DibbleJS.callApiRequest(params, response => {
          if (DibbleApi.isResponseSuccess(response)) {
            this.creditcards = response.creditcards
          } else {
            DibbleJS.toastErrorMessage(response.message);
          }
        });
      } else {
        DibbleJS.toastErrorMessage(response.message)
      }
    },
    _onLoadOrderFailed() {
      DibbleJS.hideLoader();
      DibbleJS.toastErrorMessage('Something wrong! can not load data');
    },
    onGetRentalBoatExtras(){
      const params = {
        request: DibbleAPI.api.getRentalBoatExtras,
        order_id: this.orderId
      }
      DibbleJS.callApiRequest(params, this._onBoatExtrasSuccess)
    },

    _onBoatExtrasSuccess(response){
      if (DibbleApi.isResponseSuccess(response)) {
        const { cart_items } = response
        this.cartItems = cart_items
      } else {
        DibbleJS.toastErrorMessage(response.message)
      }
    },
    onCloseOrderClick(){
      this.isShowCloseOrderModal = true
    },
    onCloseOrderClose() {
      this.isShowCloseOrderModal = false
      this.loadOrderInfo()
    },
    onAddCardClick(){
      const params = {
        request: DibbleApi.api.authorizeUserCreditcards,
        user_id: this.order.order_info.client_user_id,
        return_url: window.location.href
      }
      DibbleJS.showLoader()
      DibbleJS.callApiRequest(params, response => {
        DibbleJS.hideLoader()
        if (DibbleApi.isResponseSuccess(response)) {
          window.location.href=response.checkout_url
        } else {
          DibbleJS.toastErrorMessage(response.message);
        }
      });
    },
    onPayClick() {
      const params = {
        request: DibbleApi.api.closeRentalBoatPayments,
        order_id: this.order.order_info.order_id,
        creditcard_id: this.selectedCardId
      };
      DibbleJS.showLoader();
      DibbleJS.callApiRequest(params, response => {
        DibbleJS.hideLoader();
        if (DibbleApi.isResponseSuccess(response)) {
          DibbleJS.toastSuccessMessage(response.message);
          this.$emit("close");
        } else {
          DibbleJS.toastErrorMessage(response.message);
        }
      });
    },
    onSavedAddPayedItem() {
      this.showModalAddPaidItem = false;
      this.loadOrderInfo()
    },
    deleteCartItem(id) {
      DibbleJS.confirmBox('Are you sure you want to remove this item?', () => {
        DibbleJS.showLoader()
        DibbleJS.callApiRequest({
          request: DibbleApi.api.removeRentalBoatPayedItem,
          order_id: this.orderId,
          cart_item_id: id,
        }, response => {
          DibbleJS.hideLoader();
          if (DibbleApi.isResponseSuccess(response)) {
            DibbleJS.toastSuccessMessage(response.message)
            this.loadOrderInfo()
          } else {
            DibbleJS.toastErrorMessage(response.message)
          }
        })
      })
    },
  }
};
</script>

<style lang="scss" scoped>
.payment-page {
  margin: 20px 70px;
  display: flex;
  flex-direction: column;
  user-select: none;
  min-width: 900px;
  p {
    font-family: "Open Sans";
    font-style: normal;
  }
  .title-payment {
    display: flex;
    justify-content: space-between;
    p {
      font-weight: 600;
      font-size: 22px;
      color: #1c5169;
    }
    button {
      background: #1c5169;
      box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
      border-radius: 20px;
      width: 61px;
      height: 47px;
      color: #fff;
      font-size: 30px;
      border: none;
    }
  }

  table {
    width: 100%;
    user-select: none;
    tr {
      &:last-child {
        border-bottom: none;
      }
      &:nth-last-child(2) {
        border-bottom: 1.5px solid #2c94ab;
      }
      user-select: none;
      border-bottom: 1.5px solid #dee6ea;
    }
    th {
      padding-top: 20px;
      padding-bottom: 20px;
      user-select: none;
    }
    .name-add {
      font-family: "Open Sans";
      font-style: normal;
      font-weight: 600;
      font-size: 20px;
      line-height: 24px;
      color: #555e67;
    }
    .text-payment {
      font-family: "Open Sans";
      font-style: normal;
      font-weight: 400;
      font-size: 20px;
      line-height: 24px;
      color: #7c7c7a;
    }
    .text-value {
      font-family: "Open Sans";
      font-style: normal;
      font-weight: 600;
      font-size: 20px;
      line-height: 24px;
      text-align: right;
      color: #2c94ab;
    }
    .result-line {
      .text-result {
        font-family: "Open Sans";
        font-style: normal;
        font-weight: 600;
        font-size: 20px;
        line-height: 24px;
        color: #2c94ab;
      }
      .refund-value {
        font-family: "Open Sans";
        font-style: normal;
        font-weight: 600;
        font-size: 20px;
        line-height: 24px;
        text-align: right;
        color: #555e67;
      }
    }
  }
  .btn-pay {
    font-weight: 600;
    font-size: 20px;
    line-height: 18px;
    color: #ffffff;
    background: #1c5169;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
    border-radius: 100px;
    padding: 20px 20px;
    border: none;
    font-family: "Open Sans";
    font-style: normal;
  }
  // dialog
  .text-note {
    width: 100%;
    background: #e8eff1;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
    border-radius: 30px;
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 22px;
    color: #7c7c7a;
    padding: 20px;
    border: none;
  }
  .select-credit {
    width: 100%;
    background: #e8eff1;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
    border-radius: 30px;
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 22px;
    color: #7c7c7a;
    padding: 10px 20px 50px;
		&:nth-child(2) {
			padding: 20px !important;
		}
    border: none;
    .text-credit {
      font-family: "Open Sans";
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      letter-spacing: 0.01em;
      color: #7c7c7a;
      margin: 0;
    }
    .title-credit-card {
      font-family: "Open Sans";
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      line-height: 22px;
      letter-spacing: 0.01em;
      color: #555e67;
    }
  }
  .btn-dialog {
    width: 180px;
    height: 60px;
    background: #d9d9d9;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
    border-radius: 10px;
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 18px;
    text-align: space-between;
    color: #ffffff;
    border: none;
  }
  .ok-btn {
    background: #2178ab;
    color: #ffffff;
  }

  // checkbox
  .checkbox-custom {
    display: block;
    position: relative;
    padding-left: 35px;
    margin-bottom: 15px;
    cursor: pointer;
    font-size: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  /* Hide the browser's default checkbox */
  .checkbox-custom input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
    border: none;
  }

  /* Create a custom checkbox */
  .checkmark-new {
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    background-color: #2c94ab;
    border: none !important;
    border-radius: 9px;
  }

  /* When the checkbox is checked, add a blue background */
  .checkbox-custom input:checked ~ .checkmark-new {
    background-color: #2c94ab;
  }

  /* Show the checkmark when checked */
  .checkbox-custom input:checked ~ .checkmark-new:after {
    display: block;
  }

  /* Style the checkmark/indicator */
  .checkbox-custom .checkmark-new:after {
    content: "";
    position: absolute;
    display: none;
    left: 6px;
    top: 2px;
    width: 8px;
    height: 12px;
    border: solid white;
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(40deg);
    -ms-transform: rotate(40deg);
    transform: rotate(40deg);
  }
}
</style>
